import React from 'react';

function Varification(props: object) {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.74898 3.8785C9.71648 3.87308 9.67857 3.87308 9.64607 3.8785C8.89857 3.85141 8.30273 3.23933 8.30273 2.481C8.30273 1.70641 8.92565 1.0835 9.70023 1.0835C10.4748 1.0835 11.0977 1.71183 11.0977 2.481C11.0923 3.23933 10.4965 3.85141 9.74898 3.8785Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.19203 7.82192C9.93412 7.9465 10.752 7.8165 11.3262 7.43192C12.09 6.92275 12.09 6.08858 11.3262 5.57942C10.7466 5.19483 9.91786 5.06483 9.17578 5.19483"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.23352 3.8785C3.26602 3.87308 3.30393 3.87308 3.33643 3.8785C4.08393 3.85141 4.67977 3.23933 4.67977 2.481C4.67977 1.70641 4.05685 1.0835 3.28227 1.0835C2.50768 1.0835 1.88477 1.71183 1.88477 2.481C1.89018 3.23933 2.48602 3.85141 3.23352 3.8785Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.79096 7.82192C3.04888 7.9465 2.23096 7.8165 1.6568 7.43192C0.893047 6.92275 0.893047 6.08858 1.6568 5.57942C2.23638 5.19483 3.06513 5.06483 3.80721 5.19483"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.49898 7.9244C6.46648 7.91898 6.42857 7.91898 6.39607 7.9244C5.64857 7.89731 5.05273 7.28523 5.05273 6.5269C5.05273 5.75231 5.67565 5.12939 6.45023 5.12939C7.22482 5.12939 7.84773 5.75773 7.84773 6.5269C7.84232 7.28523 7.24648 7.90273 6.49898 7.9244Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.92438 9.63082C4.16063 10.14 4.16063 10.9742 4.92438 11.4833C5.79104 12.0629 7.21021 12.0629 8.07687 11.4833C8.84062 10.9742 8.84062 10.14 8.07687 9.63082C7.21562 9.05665 5.79104 9.05665 4.92438 9.63082Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Varification;
